import { TablePaginationConfig } from 'antd'
import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import DetergentHistoriesPageHeader from '@/components/pages/DetergentHistories/List/PageHeader'
import DetergentHistoriesTable from '@/components/pages/DetergentHistories/List/Table'
import routes from '@/constants/routes'
import { DetergentHistory } from '@/types'

import { useDetergents } from '../Detergents/Detergent.hooks'
import { useDetergentHistories } from './DetergentHistory.hooks'

const DetergentHistories = () => {
  const { id } = useParams()
  const navigate = useNavigate()

  const {
    getDetergentHistoriesLoading,
    getDetergentHistoriesResponse,
    getDetergentHistories,
    deleteDetergentHistory,
    filterToQuery,
    page,
    pageSize,
  } = useDetergentHistories()

  const { getDetergentDetail, getDetergentDetailResponse } = useDetergents()

  const handleDeleteMachinePart = async (id: DetergentHistory['id'], detergentId: number) => {
    await deleteDetergentHistory({ id })
    getDetergentHistories({ detergentId, page, limit: pageSize })
  }

  const totalItems = getDetergentHistoriesResponse?.meta.totalItems || 0

  useEffect(() => {
    if (id) {
      getDetergentHistories({ detergentId: Number(id), page, limit: pageSize })
      getDetergentDetail(Number(id))
    }
  }, [getDetergentDetail, getDetergentHistories, id, page, pageSize])

  const handleChangePage = (config: TablePaginationConfig) => {
    navigate({
      pathname: routes.detergentHistories.path,
      search: filterToQuery({
        page: config.current ?? page,
      }),
    })
  }

  return (
    <>
      <DetergentHistoriesPageHeader name={getDetergentDetailResponse?.name || ''} />
      <DetergentHistoriesTable
        detergentId={Number(id)}
        {...{
          dataSource: getDetergentHistoriesResponse?.items,
          dataSourceDetail: getDetergentDetailResponse ? [getDetergentDetailResponse] : [],
          getDetergentHistoriesLoading,
          page,
          pageSize,
          totalItems,
          onChange: handleChangePage,
        }}
        onDelete={handleDeleteMachinePart}
      />
    </>
  )
}

DetergentHistories.displayName = 'DetergentHistories'
export default DetergentHistories
